import useModal from 'hooks/useModal';
import { getInvoiceInfo, InvoiceInfo } from 'services/api/conversation';
import InvoiceModal from './InvoiceModal';
import { toUpperCase } from 'utils/toLowerCase';
import StatusButton from 'components/StatusButton';
import { useCallback } from 'react';
import { message } from 'antd';
import { useTranslate } from '@tolgee/react';

interface TradeInvoiceProps {
  platform: General.Platform;
  region: General.UpperCaseRegion;
  buyerNick: string;
  externalTradeId: string;
  internalBuyerId: number;
  internalStoreId: string;
  trade: Conversation.Trade.Vo;
  renderButton?: (onClick: () => Promise<void>) => React.ReactNode;
}

export const TradeInvoice = (props: TradeInvoiceProps) => {
  const {
    platform,
    region,
    buyerNick,
    externalTradeId,
    internalBuyerId,
    internalStoreId,
    trade,
    renderButton,
  } = props;
  const { t } = useTranslate();
  const { visible, show, hide, update, meta } = useModal<InvoiceInfo>();

  const onClick = useCallback(() => {
    if (meta) {
      show(meta);
      return Promise.resolve();
    }
    return getInvoiceInfo({
      externalTradeId,
      internalBuyerId,
      internalStoreId,
    })
      .then(show)
      .catch(() => {
        message.error(t('scene.chatWorkspace.orderTab.error.fetchFailed'));
      });
  }, [externalTradeId, internalBuyerId, internalStoreId, meta, show, t]);

  return (
    <>
      {renderButton ? (
        renderButton(onClick)
      ) : (
        <StatusButton onClick={onClick}>
          {t('scene.chatWorkspace.orderTab.orderDetail.action.viewReceipt')}
        </StatusButton>
      )}
      {meta && (
        <InvoiceModal
          platform={toUpperCase(platform)}
          region={region}
          buyerNick={buyerNick}
          invoiceInfo={meta}
          trade={trade}
          visible={visible}
          onCancel={() => hide()}
          afterClose={() => update(false, undefined)}
        />
      )}
    </>
  );
};
